<div class="input-container">
    <input
        data-uit="search-input"
        type="text"
        class="search-field form-control"
        title="{{ _placeholder }}"
        [(ngModel)]="searchTerm"
        (ngModelChange)="_onSearchTermChange()"
        placeholder="{{ _placeholder }}"
        [caAutoFocus]="autoFocusSearchField"
        [disabled]="isSearchLoading"
        #searchInput
    />
    <ca-icon *ngIf="searchTerm == ''" name="search" size="s" class="search-icon"></ca-icon>
    <button type="button" *ngIf="searchTerm !== ''" class="btn ca-btn-icon delete-button" data-uit="search-input-clear-btn" (click)="onDeleteClick()">
        <ca-icon name="cross" size="s"></ca-icon>
    </button>
</div>
